import { GetStaticProps, NextPage } from 'next'
import { FaCrown } from 'react-icons/fa'
import { RankingBookList } from 'web_core/assets/book'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { ESBook } from 'web_core/elastic_search'
import { useESBooks } from 'web_core/hooks'
import { Serialized, deserializeArray } from 'web_core/utils'
import { DefaultLayout } from '~/components/Layout/Default'
import { ContentNavSelector } from '~/components/Utils/ContentNavSelector'
import { Heading } from '~/components/Utils/Heading'
import { useLayoutProperty } from '~/context/layout_property'
import { LayoutStaticProps } from '~/static_props/layout'
import { getBooksRankingStaticProps } from '~/static_props/ranking'
import { bookRankingBreadcrumb } from '~/utils'

type Props = {
  books: Serialized<ESBook>[]
} & LayoutStaticProps

export const getStaticProps: GetStaticProps<Props> = async ({
  locale = 'ja',
}) => {
  return getBooksRankingStaticProps(locale)
}

const ContentsMenu = () => {
  const { headerHeight } = useLayoutProperty()
  return (
    <div
      className="sticky-top bg-white pt-2 pb-2 mb-2"
      style={{ top: headerHeight }}
    >
      <ContentNavSelector active="books" link="/ranking/[contents]" />
    </div>
  )
}

const Page: NextPage<Props> = ({
  books: staticBooks,
  categories,
  popularProfiles,
}) => {
  const { books } = useESBooks(
    {
      type: 'ranking',
      locale: 'ja',
    },
    deserializeArray(staticBooks, {})
  )
  return (
    <DefaultLayout
      head={{
        title: '歴代本ランキング',
        description:
          '歴代でユーザからの高評価が多かった上位20冊の本をご覧いただけます。',
        keyword: 'ランキング',
      }}
      navLinks={{ pc: true, tablet: true, sp: true, active: 'ranking' }}
      categoriesMenu={{ pc: true, sp: true }}
      staticCategories={categories}
      staticPopularProfiles={popularProfiles}
      leftSidebar
      rightSideBar
    >
      {bookRankingBreadcrumb.toReactNode()}
      <Heading title="ランキング" icon={FaCrown} className="mb-0" />
      <ContentsMenu />
      {books ? (
        <RankingBookList books={books} className="grid g-cols-1 g-lg-cols-2" />
      ) : (
        <LoadingSpinner />
      )}
    </DefaultLayout>
  )
}

export default Page
